import React from 'react';
import { useParams } from 'react-router-dom';
import './Project.css';

function Project() {
  return (
    <div className="project-page">
    </div>
  );
}

export default Project;
